//export const GOODMODEMANAGESUPERADMIN = 'GODMODEMANAGESUPERADMIN'
export const SUPERADMINMANAGEMAILBOX = "SUPERADMINMANAGEMAILBOX";
